import Vue from 'vue'
import authDialog from './authDialog.vue'

const DialogContructor = Vue.extend(authDialog)

const DialogAuth = (options = {}) => {
  const parent = document.querySelector('#app').children[0]
  const instance = new DialogContructor({
    el: document.createElement('div'),
    data: options
  })
  parent.appendChild(instance.$el)
}

export default DialogAuth
